import "./style.css";
import {
  LuBox,
  LuCalendarDays,
  LuClock,
  LuDatabase,
  LuFileText,
  LuMap,
  LuMaximize2,
  LuStore,
} from 'react-icons/lu';

const metricIcons = {
  area: LuMaximize2,
  siteArea: LuMap,
  year: LuCalendarDays,
  volume: LuDatabase,
  lod: LuBox,
  format: LuFileText,
  timeline: LuClock,
  type: LuStore,
};

const ProjectMetrics = ({ data, projectId, useProject01Template = false }) => {
  if (!data?.items?.length) return null;
  return (
    <section
      className="project-case-card project-metrics"
      data-project-id={projectId}
      data-project-template={useProject01Template ? 'project-01' : undefined}
    >
      <h2 className="project-case-card__title">{data.title}</h2>

      <div className={`project-metrics__grid${data.equalHeight ? ' project-metrics__grid--equal-height' : ''}`}>
        {data.items.map(({ id, label, value }) => {
          const Icon = metricIcons[id];
          return (
          <article className="project-metrics__item" key={id}>
            <span className="project-metrics__icon">
              {Icon ? <Icon /> : null}
            </span>
            <span className="project-metrics__label">{label}</span>
            <strong>{value}</strong>
          </article>
          );
        })}
      </div>
    </section>
  );
};

export default ProjectMetrics;
